import React, {Component} from 'react';
import TuneIcon from "@material-ui/icons/Tune";
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";
import Button from "@material-ui/core/Button";
import Divider from "@material-ui/core/Divider";
import Collapse from "@material-ui/core/Collapse";
import TextField from "@material-ui/core/TextField";
import InputAdornment from "@material-ui/core/InputAdornment";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import {FormGroup, FormLabel, Radio, RadioGroup} from "@material-ui/core";
import FormControl from "@material-ui/core/FormControl";


class CollapsibleScatteredRegionsVisitationAdvancedOptions extends Component {


    state = {
        open: false,
    }

    handleClick = () => {
        this.setState({
            open: !this.state.open
        })
    }

    render() {

        const {project} = this.props;

        return (
            <div >
                <Button onClick={this.handleClick}>
                    <TuneIcon/>Advanced
                    {this.state.open ? <ExpandLess/> : <ExpandMore/>}
                </Button>
                <Collapse in={this.state.open} timeout={"auto"} unmountOnExit>
                    <div>
                        <Divider/>
                        <div>
                            <TextField style={{width: '100px', padding: '20px'}}
                                       id="standard-name"
                                       label="Max Altitude"
                                       value={project.maxAltitude}
                                       onChange={(evt) => this.props.onProjectChange('maxAltitude', evt)}
                                       InputProps={{
                                           endAdornment: <InputAdornment
                                               position="end">m</InputAdornment>,
                                       }}
                                       margin="normal"
                            />
                        </div>
                        <div>
                            <TextField style={{width: '100px', padding: '20px'}}
                                       id="standard-name"
                                       label="Min Altitude"
                                       value={project.minAltitude}
                                       onChange={(evt) => this.props.onProjectChange('minAltitude', evt)}
                                       InputProps={{
                                           endAdornment: <InputAdornment
                                               position="end">m</InputAdornment>,
                                       }}
                                       margin="normal"
                            />
                        </div>
                        <div>
                            <TextField style={{width: '100px', padding: '20px'}}
                                       id="standard-name"
                                       label="Flight Altitude"
                                       value={project.flightAltitude}
                                       onChange={(evt) => this.props.onProjectChange('flightAltitude', evt)}
                                       InputProps={{
                                           endAdornment: <InputAdornment
                                               position="end">m</InputAdornment>,
                                       }}
                                       margin="normal"
                            />
                        </div>

                        <div>
                            <TextField style={{width: '100px', padding: '20px'}}
                                       id="standard-name"
                                       label="Speed"
                                       value={project.horizontalSpeed}
                                       onChange={(evt) => this.props.onProjectChange('horizontalSpeed', evt)}
                                       InputProps={{
                                           endAdornment: <InputAdornment
                                               position="end">m/s</InputAdornment>,
                                       }}
                                       margin="normal"
                            />
                        </div>
                        <div>
                            <FormControl component="fieldset">
                                <FormLabel component="legend">Image Capture</FormLabel>
                                <RadioGroup aria-label="iouMetric" name="iouMetric" value={project.iouMetric.toString()} onChange={
                                    (evt) => this.props.onProjectChange('iouMetric', evt)}>
                                    <FormControlLabel value='false' control={<Radio />} label="Maximized Coverage" />
                                    <FormControlLabel value='true' control={<Radio />} label="Balanced Coverage" />
                                </RadioGroup>
                            </FormControl>
                        </div>
                    </div>
                </Collapse>
            </div>
        )

    }

}

export default CollapsibleScatteredRegionsVisitationAdvancedOptions
